import React, { useRef, useState } from "react";
import SingularPromoteTemplate from "./SingularPromoteTemplate";
import ChantButton from "../../../../../CommonComponents/ChantButton/ChantButton";
import "./Posters.css";
import { Radio } from "antd";

const Posters = () => {
  const singularCanvasRef = useRef(null);
  const [hasSingularLoaded, setHasSingularLoaded] = useState(false);

  const handleSingularDownload = async () => {
    try {
      const canvas = singularCanvasRef.current;
      if (!canvas) return;

      // Create a temporary canvas to ensure proper rendering
      const tempCanvas = document.createElement("canvas");
      const tempCtx = tempCanvas.getContext("2d");
      tempCanvas.width = canvas.width;
      tempCanvas.height = canvas.height;

      // Draw the content to the temporary canvas
      tempCtx.drawImage(canvas, 0, 0);

      // Convert to blob first to handle cross-origin issues
      const blob = await new Promise((resolve) =>
        tempCanvas.toBlob(resolve, "image/png", 1.0)
      );
      if (!blob) {
        throw new Error("Failed to create blob from canvas");
      }

      // Create and trigger download
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.download = "social-post.png";
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download image. Please try again.");
    }
  };

  const [singularPosterType, setSingularPosterType] = useState("option1");

  const handleSingularPosterTypeChange = (e) => {
    setSingularPosterType(e.target.value);
  };

  return (
    <div className="promote-content-container">
      <div>
        <SingularPromoteTemplate
          posterType={singularPosterType}
          canvasRef={singularCanvasRef}
          hasSingularLoaded={hasSingularLoaded}
          setHasSingularLoaded={setHasSingularLoaded}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <p>Choose style: </p>

          <Radio.Group
            onChange={handleSingularPosterTypeChange}
            value={singularPosterType}
            style={{ marginBottom: 8 }}
          >
            <Radio.Button value="option1">Option 1</Radio.Button>
            <Radio.Button value="option2">Option 2</Radio.Button>
          </Radio.Group>
        </div>

        <div>
          <ChantButton
            onClick={handleSingularDownload}
            loading={!hasSingularLoaded}
          >
            Download as PNG
          </ChantButton>
        </div>
      </div>

      {/* <DualPromoteTemplate /> */}
    </div>
  );
};

export default Posters;
